import { Button, DialogContentText } from '@mui/material';
import React from 'react';
import ErrorDialog from '../error-dialog/ErrorDialog';
import { useGetErrorMessage } from '../utils/useGetErrorMessage';

export interface SimulationErrorDialogProps {
  retry: () => void;
  error?: Response;
}

const SimulationErrorDialog = ({ retry, error }: SimulationErrorDialogProps) => {
  const [errorMessage, showErrorDialog, setShowErrorDialog] = useGetErrorMessage(error);

  return (
    <ErrorDialog
      open={showErrorDialog}
      message={
        <DialogContentText color="text.primary" variant="body1">
          {errorMessage}
        </DialogContentText>
      }
    >
      <Button onClick={() => setShowErrorDialog(false)}>Dismiss</Button>
      <Button onClick={() => retry()} variant="contained">
        Try again
      </Button>
    </ErrorDialog>
  );
};

export default SimulationErrorDialog;
